import React from 'react';
import axios from 'axios';
import { reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import FlashMessage from 'src/components/FlashMessage/FlashMessage';
import { DESK_GROUP_COMPANY_SETTINGS } from 'src/constants/EndpointUrls';
import styles from './GroupCompanySettingForm.scss'


class GroupCompanySettingForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSuccess: false,
      isOpen: false
    }
  }

  render() {
    const client = this.props.client;
    const { handleSubmit } = this.props;
    const group_company_id = this.props.match.params.id;

    const onSubmit = values => {
      axios.put(`/desk/group_company_settings/${group_company_id}`, {
        client_id: client.id,
        isDisplayGroupCompanySetting: values.isDisplayGroupCompanySetting
      })
      .then(response => {
        if (response.status === 200) {
          this.props.setOpen();
          this.props.setSuccess();
          setTimeout(() => {
            window.location.replace(DESK_GROUP_COMPANY_SETTINGS);
          }, 1000)
        }
      })
      .catch((e) => {
        this.props.setOpen();
        this.props.setUnSuccess();
      });
    }

    return(
      <React.Fragment>
          <FlashMessage successMessage="Successfully update." failedMessage="Failed update." />
          <div className="w-25">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="alert alert-warning">Client Name: {client.name}</div>
            <div className="form-group">
              <Field　className={styles.isDisplayGroupCompanySetting} name="isDisplayGroupCompanySetting" component="select" >
                <option>Please select</option>
                <option value="enable">enable</option>
                <option value="disable">disable</option>
              </Field>
            </div>

            <button className="btn btn-success" type="submit">Submit</button>

          </form>
          </div>

      </React.Fragment>
　　 )
　}　
}

const mapStateToProps = state => ({
  isSuccess: state.flashMessage.isSuccess,
  isOpen: state.flashMessage.isOpen
})

const mapDispatchToProps = dispatch => ({
  setSuccess: () => dispatch({type: 'SET_SUCCESS'}),
  setUnSuccess: () => dispatch({type: 'SET_UNSUCCESS'}),
  setOpen: () => dispatch({type: 'SET_OPEN'})
})

export default reduxForm({
  form: "groupCompanySettingForm",
})(connect(mapStateToProps, mapDispatchToProps)(GroupCompanySettingForm));